import React from "react";

const RunsheetIcon = (props) => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1039_10455)">
          <g opacity="0.8">
            <path
              d="M21 4H3C2.44772 4 2 4.44772 2 5V19C2 19.5523 2.44772 20 3 20H21C21.5523 20 22 19.5523 22 19V5C22 4.44772 21.5523 4 21 4Z"
              stroke={props?.color ?? "black"}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16 12.5V16M12 8V16M8 10V16"
              stroke={props?.color ?? "black"}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1039_10455">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default RunsheetIcon;
